"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useLabelDisplayedRows = function (translate) {
    var labelDisplayedRows = (0, react_1.useCallback)(function (_a) {
        var from = _a.from, to = _a.to, count = _a.count;
        var totalCount = count !== -1 ? count : "".concat(translate('moreThan', 'more than'), " ").concat(to);
        return ("\n      ".concat(from, "-").concat(to, "\n      ").concat(translate('of', 'of'), "\n      ").concat(totalCount, "\n    "));
    }, [translate]);
    return labelDisplayedRows;
};
exports.default = useLabelDisplayedRows;
